import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import partnerApi from '../api/partnerApi';

/**
 * Attribution capture page — /ref/:code
 * 1. Records the referral visit server-side
 * 2. Stores the referral code in localStorage for later attribution
 * 3. Redirects to /register
 */
export default function RefPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!code) { navigate('/register'); return; }

    const referralCode = code.toUpperCase();
    // Generate/reuse visitor ID
    let visitorId = localStorage.getItem('partner_visitor_id');
    if (!visitorId) {
      visitorId = crypto.randomUUID?.() || Math.random().toString(36).slice(2);
      localStorage.setItem('partner_visitor_id', visitorId);
    }

    // Store for attribution during school registration
    localStorage.setItem('partner_ref_code', referralCode);

    // Fire-and-forget server-side tracking
    partnerApi.post('/track', {
      referral_code: referralCode,
      visitor_id: visitorId,
      session_id: sessionStorage.getItem('session_id') || visitorId,
      landing_page: window.location.href,
      utm_source: searchParams.get('utm_source'),
      utm_medium: searchParams.get('utm_medium'),
      utm_campaign: searchParams.get('utm_campaign'),
    }).catch(() => {});

    // Redirect to main school registration
    navigate(`/register?ref=${referralCode}`);
  }, [code]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-4 border-[#516EFA] border-t-transparent animate-spin mx-auto mb-3" />
        <p className="text-slate-500 text-sm">Redirecting...</p>
      </div>
    </div>
  );
}
